<template>
  <div id="content"
       class="container">
    <div class="toAsk-left-wrap">
      <header>
        <div class="integralBreadcrumb">
          <div class="integralBreadcrumb-item"
               @click="routerHandle('onlineTraining')">首页</div>
          <div class="el-icon-arrow-right jt"></div>
          <div class="integralBreadcrumb-item"
               @click="routerHandle('postBarList')">贴吧</div>
          <div class="el-icon-arrow-right jt"></div>
          <div class="integralBreadcrumb-item">我要提问</div>
        </div>
      </header>
      <main>
        <el-form ref="dataForm"
                 :model="dataForm"
                 label-width="130px"
                 :rules="rules"
                 :validate-on-rule-change="false">
          <el-form-item label="分类："
                        prop="classify">
            <el-col :span="16">
              <el-input v-model="dataForm.classify"
                        placeholder="课程问答"
                        :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="标题："
                        prop="questionTitle">
            <el-col :span="16">
              <el-input v-model="dataForm.questionTitle"
                        placeholder="问题标题不少于16个字"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="内容："
                        prop="questionContent">
            <el-col :span="16">
              <el-input v-model="dataForm.questionContent"
                        placeholder="简洁，明了，能引起思考和讨论的知识性的内容"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
                        class="tag"
                        label="标签："
                        prop="label">
            <el-col :span="16">
              <el-select v-model="dataForm.label"
                         multiple
                         :multiple-limit=3
                         placeholder="请最多选择3个标签">
                <el-option v-for="item in dataForm.labelList"
                           :key="item.id"
                           :label="item.typeAttributeValue"
                           :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="验证码："
                        prop="captcha">
            <el-row>
              <el-col :span="12">
                <el-input v-model="dataForm.captcha"
                          placeholder="请输入验证码">
                </el-input>
              </el-col>
              <el-col :span="10"
                      class="login-captcha">
                <img :src="dataForm.captchaPath"
                     style="width:120px;float:left;height:40px;cursor:pointer"
                     @click="getCaptcha()"
                     alt="">
              </el-col>
            </el-row>
          </el-form-item> -->
        </el-form>
        <el-button type="primary"
                   style="margin-left:128px;width:270px;height:40px;background:#1D65A8;border:1px solid #1D65A8;color:#fff"
                   @click="submitAsk">提问</el-button>
      </main>
    </div>
    <div class="toAsk-right-wrap">
      <div class="toAsk-title">
        <img src="https://i-learning.supcon.com/static/supereduweb/img/tipQe.png" />
        <h5>亲，您要提问吧？要知道这些哦！</h5>
      </div>
      <div class="toAsk-first">
        <h6>一、需要了解的事情：</h6>
        <p class="toAsk-p">1、您是想来吐槽的吧，没事，随便发吧。有人会跟你一起吐槽的。</p>
        <p class="toAsk-p">2、您是来解决问题？请先搜索是否已经有同类问题吧。这样您就省心少打字。</p>
        <p class="toAsk-p">3、没找到是么？就在发问题时精确描述你的问题，不要写与问题无关的内容哟。</p>
        <p class="toAsk-p">4、问答更热衷于解达您想要的答案。能引起思考和讨论的知识性问题；</p>
      </div>
      <div class="toAsk-first">
        <h6>二、要注意的事情：</h6>
        <p class="toAsk-p">1、禁止发布求职、交易、推广、广告类与问答无关信息将一律清理。</p>
        <p class="toAsk-p">2、尽可能详细描述您的问题，如标题与内容不符，或与问答无关的信息将被关闭。</p>
        <p class="toAsk-p">3、问答刷屏用户一律冻结帐号。</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getUUID } from '@/utils'
export default {
  data () {
    var validator = (rule, value, callback) => {
      if (this.dataForm.label.length === 0) {
        callback(new Error('请至少选择一个标签'))
      } else {
        callback()
      }
    }
    return {
      butLoading: false,
      dataForm: {
        classify: '',
        questionTitle: '',
        questionContent: '',
        label: [],
        labelList: [],
        attTags: [],
        id: '',
        captcha: '',
        captchaPath: ''
      },
      rules: {
        questionTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 16, message: '标题长度不少于16个字', trigger: 'blur' }
        ],
        label: [
          { required: true, message: '请至少选择一个标签', trigger: 'blur' },
          { validator: validator, trigger: 'blur' }
        ],
        questionContent: [
          { required: true, message: '提问内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getLabel()
    this.getCaptcha()
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'postBarList') {
        this.$router.push({ name: 'postBarList' })
      }
    },
    // 获取标签列表
    getLabel () {
      this.$http.get(`/front/train/trainAttribute/selectAllAttrbute`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm.labelList = res.data
          }
        })
    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.dataForm.captchaPath = `${window.SITE_CONFIG['apiURL']}/front/consumer/sysCaptcha/${this.dataForm.uuid}`
    },
    submitAsk () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.butLoading = true
          this.$http.post(`/front/train/trainQuestionAnswer/saveQuestionAtFrontGround`,
            {
              'questionContent': this.dataForm.questionContent,
              'questionTitle': this.dataForm.questionTitle,
              'attTags': this.dataForm.label,
              'uuid': this.dataForm.uuid,
              'code': this.dataForm.captcha
            }
          )
            .then(({ data: res }) => {
              if (res && res.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.butLoading = false
                    this.$router.push(
                      { name: 'questionInfo', query: { id: res.data } }
                    )
                  }
                })
              } else {
                this.$message.error(res.msg || '提问失败')
                this.butLoading = false
              }
            })
            .catch(err => {
              this.$message.error(err.msg || '提问失败')
              this.butLoading = false
            })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.toAsk-left-wrap {
  width: 870px;
  float: left;
  min-height: 635px;
}
.all-book {
  width: 870px;
  font-weight: normal;
  margin: 20px 0;
  font-size: 26px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
}
main {
  width: 870px;
  background: #fff;
  height: 460px;
  padding-top: 20px;
}
.toAsk-right-wrap {
  float: right;
  width: 290px;
  // height: 494px;
  background: #fff;
  padding-top: 30px;
  padding-left: 10px;
  margin-top: 60px;
}
.toAsk-title {
  width: 290px;
  height: 75px;
}
.toAsk-title img {
  width: 70px;
  height: 70px;
  margin-right: 20px;
  float: left;
}
.toAsk-title h5 {
  float: left;
  width: 144px;
  font-size: 18px;
  font-weight: normal;
  margin: 0;
}
.toAsk-first {
  margin-top: 20px;
}
.toAsk-p {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
.list-tag {
  background: #f2efed;
  color: #787d82;
  float: left;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  margin-right: 5px;
  margin-bottom: 5px;
}
/* 问答标签*/
.tag{
  .el-select{
    width:100%;
    .el-input{
      width:100%;
    }
  }
}
</style>
